import React, { useState } from "react";
import IconButton from "@material-ui/core/IconButton";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";
import MoreVertIcon from "@material-ui/icons/MoreVert";

const MENU_OPTIONS = [
  { label: "View Sensor Details", value: "details" },
  { label: "Edit Display Name", value: "rename" },
  { label: "Change Assignment", value: "assign" },
];
export const SensorSettingsMenu = ({ row, menuItemHandler }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const isOpen = Boolean(anchorEl);

  const handleOpenMenu = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = (option, row) => {
    menuItemHandler(option, row);
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        aria-label="Open sensor settings menu"
        aria-controls={isOpen ? "sensor-settings-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={isOpen ? "true" : undefined}
        onClick={handleOpenMenu}
        size="small"
      >
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="sensor-settings-menu"
        anchorEl={anchorEl}
        open={isOpen}
        onClose={handleCloseMenu}
        onClick={(event) => event.stopPropagation()}
        keepMounted
      >
        {MENU_OPTIONS.map((option) => (
          <MenuItem
            key={option.value}
            onClick={() => {
              handleCloseMenu(option, row);
            }}
          >
            {option.label}
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
